import { useEffect, useRef } from 'react';

export function useConditionalEffect(
  callback: VoidFunction,
  shouldTrigger: boolean
): void {
  const func = useRef(callback);

  func.current = callback;

  useEffect(() => {
    if (shouldTrigger) {
      func.current();
    }
  }, [shouldTrigger]);
}
